module.exports = __webpack_public_path__ + "saira-medium-webfont.95f5ece8975e515a2853.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-medium-webfont.svg
// module id = ../../../../../src/assets/fonts/saira-medium-webfont.svg
// module chunks = styles